import { useState } from 'react'
import { Link } from 'react-router-dom'
import './Ajuda.css'

const secoes = [
    {
        id: 'comprador',
        icone: '🛒',
        titulo: 'Como Comprar',
        subtitulo: 'Encontre e negocie animais e produtos agropecuários',
        cor: '#22c55e',
        passos: [
            {
                numero: 1,
                titulo: 'Crie sua conta gratuitamente',
                descricao: 'Acesse a página de cadastro, preencha seu nome, e-mail e senha. Sua conta já vem habilitada como comprador automaticamente.',
                dica: 'Você não precisa pagar nada para comprar na Agroov.'
            },
            {
                numero: 2,
                titulo: 'Navegue pelos anúncios',
                descricao: 'Use a barra de busca na Home ou acesse a aba "Anúncios" no menu. Filtre por categoria (Bovinos, Equinos, Suínos, Aves, Ovinos ou Outros) para encontrar exatamente o que procura.',
                dica: null
            },
            {
                numero: 3,
                titulo: 'Analise os detalhes do anúncio',
                descricao: 'Clique em qualquer anúncio para ver fotos, vídeos, peso médio, idade, localização, raça e todas as informações detalhadas do lote.',
                dica: null
            },
            {
                numero: 4,
                titulo: 'Entre em contato pelo Chat',
                descricao: 'Use o botão "Conversar com o Vendedor" para abrir um chat direto e negociar preço, condições de pagamento e logística de entrega.',
                dica: 'Todas as conversas ficam salvas no menu "Mensagens" do seu perfil.'
            },
            {
                numero: 5,
                titulo: 'Salve seus favoritos',
                descricao: 'Curtiu um anúncio mas quer pensar? Clique no ícone de coração para salvar nos seus favoritos e acessar depois pelo menu "Meus Favoritos".',
                dica: null
            }
        ]
    },
    {
        id: 'vendedor',
        icone: '📢',
        titulo: 'Como Anunciar',
        subtitulo: 'Publique seus animais e produtos e alcance compradores de todo o Brasil',
        cor: '#3b82f6',
        passos: [
            {
                numero: 1,
                titulo: 'Crie sua conta e complete seu perfil',
                descricao: 'Cadastre-se e depois acesse "Meu Perfil" para completar seus dados de vendedor: CPF/CNPJ, nome da fazenda, cidade e estado.',
                dica: 'Perfis completos transmitem mais confiança para os compradores.'
            },
            {
                numero: 2,
                titulo: 'Escolha seu plano e realize o pagamento',
                descricao: 'Antes de criar seu anúncio, escolha o plano ideal e realize o pagamento via PIX. A confirmação é automática e em segundos.',
                extra: [
                    { label: 'Anúncio Avulso', valor: 'R$ 49,90 por anúncio', desc: 'Validade de 30 dias. Ideal para quem vende de vez em quando.' },
                    { label: 'Produtor Premium', valor: 'R$ 149,90/mês', desc: 'Anúncios ilimitados com validade de 60 dias cada + maior visibilidade.' }
                ],
                dica: 'O plano Premium é o mais vantajoso se você tem mais de 3 lotes para anunciar por mês.'
            },
            {
                numero: 3,
                titulo: 'Crie e publique seu anúncio',
                descricao: 'Após o pagamento, clique em "Anunciar" no menu superior. Preencha: título, categoria, raça, quantidade, peso médio, idade, preço, localização e adicione fotos e vídeos do lote.',
                dica: 'Fotos de qualidade e descrições detalhadas aumentam suas chances de venda em até 3x.'
            },
            {
                numero: 4,
                titulo: 'Gerencie suas vendas',
                descricao: 'Acesse "Meus Anúncios" para editar ou excluir seus anúncios ativos. Se o negócio foi fechado, marque como "Vendido" e construa um histórico de vendas concluídas em seu perfil. Acompanhe mensagens de compradores interessados pela aba "Mensagens".',
                dica: null
            }
        ]
    },
    {
        id: 'motorista',
        icone: '🚚',
        titulo: 'Como ser Motorista / Transportador',
        subtitulo: 'Cadastre-se e ganhe dinheiro com fretes rurais',
        cor: '#f59e0b',
        passos: [
            {
                numero: 1,
                titulo: 'Acesse "Quero Transportar"',
                descricao: 'No menu do seu perfil, clique em "Seja Motorista" ou acesse diretamente pelo menu "Motoristas" na Home.',
                dica: null
            },
            {
                numero: 2,
                titulo: 'Preencha a Ficha de Motorista',
                descricao: 'Informe seus dados de transporte: placa do veículo, tipo (Carreta Boiadeira, Bi-trem, Caminhão, Veículo Comum), capacidade de peso e quantidade de animais.',
                dica: 'Preencha todos os campos corretamente para que os produtores encontrem o transportador ideal.'
            },
            {
                numero: 3,
                titulo: 'Faça upload da foto do veículo',
                descricao: 'Adicione uma foto real do seu caminhão ou veículo. Isso aumenta muito a confiança dos produtores ao escolher um transportador.',
                dica: 'Fotos nítidas e com o veículo limpo fazem toda a diferença.'
            },
            {
                numero: 4,
                titulo: 'Realize o pagamento da assinatura',
                descricao: 'A assinatura de Motorista custa R$ 49,90/mês. Após o pagamento via PIX, seu perfil fica ativo por 30 dias com acesso total a todos os fretes disponíveis na plataforma.',
                dica: 'Você pode ser vendedor e motorista ao mesmo tempo — as validades são independentes.'
            },
            {
                numero: 5,
                titulo: 'Candidate-se a fretes',
                descricao: 'Acesse o "Painel de Fretes" no menu para ver todas as oportunidades de transporte. Candidate-se aos fretes que interessam e negocie diretamente com os vendedores.',
                dica: 'Seu perfil aparece na lista pública de motoristas, então produtores também podem te encontrar e te contratar diretamente.'
            }
        ]
    },
    {
        id: 'planos',
        icone: '💎',
        titulo: 'Planos e Preços',
        subtitulo: 'Transparência total nos valores da plataforma',
        cor: '#8b5cf6',
        passos: [
            {
                numero: 1,
                titulo: 'Anúncio Avulso — R$ 49,90',
                descricao: 'Pague por anúncio. Ideal para vendas esporádicas. Cada anúncio fica ativo por 30 dias com fotos, vídeos e negociação direta.',
                dica: null
            },
            {
                numero: 2,
                titulo: 'Produtor Premium — R$ 149,90/mês',
                descricao: 'Anúncios ilimitados com validade de 60 dias cada, maior visibilidade na Home e suporte prioritário. A assinatura mensal pode ser renovada a qualquer momento.',
                dica: 'Se você tem mais de 3 lotes para anunciar, este plano já vale a pena.'
            },
            {
                numero: 3,
                titulo: 'Transportador — R$ 49,90/mês',
                descricao: 'Acesso completo ao painel de fretes, candidatura a cargas, perfil verificado e visibilidade na lista pública de transportadores.',
                dica: 'Validade de 30 dias. Um contador no cabeçalho do site mostra quantos dias restam.'
            }
        ]
    },
    {
        id: 'seguranca',
        icone: '🛡️',
        titulo: 'Segurança',
        subtitulo: 'Como protegemos você em cada negociação',
        cor: '#ef4444',
        passos: [
            {
                numero: 1,
                titulo: 'Verificação de Identidade',
                descricao: 'Todos os vendedores e motoristas passam por verificação de CPF/CNPJ no momento do cadastro. Isso garante que você está negociando com pessoas reais.',
                dica: null
            },
            {
                numero: 2,
                titulo: 'Perfis Verificados',
                descricao: 'Vendedores e motoristas precisam completar seus dados pessoais e de negócio para serem listados na plataforma. Isso garante mais segurança nas negociações.',
                dica: null
            },
            {
                numero: 3,
                titulo: 'Chat Protegido',
                descricao: 'Todas as negociações acontecem dentro do chat da plataforma. Isso garante registro das conversas e protege ambas as partes.',
                dica: null
            },
            {
                numero: 4,
                titulo: 'Pagamentos via PIX',
                descricao: 'Os pagamentos de planos e anúncios são processados via PIX através de um gateway seguro, com confirmação automática por webhook.',
                dica: 'Nunca realize pagamentos fora da plataforma.'
            }
        ]
    }
]

const faqItems = [
    { pergunta: 'Preciso pagar para comprar na Agroov?', resposta: 'Não! Criar conta e comprar é totalmente gratuito. Você só paga se quiser anunciar ou se tornar motorista.' },
    { pergunta: 'Posso ser vendedor e motorista ao mesmo tempo?', resposta: 'Sim! Sua conta é universal. Cada serviço tem sua própria validade e assinatura independente.' },
    { pergunta: 'Como funciona a validade do plano?', resposta: 'Os planos mensais (Premium e Motorista) têm validade de 30 dias a partir da confirmação do pagamento. Um contador no cabeçalho mostra quantos dias restam.' },
    { pergunta: 'A plataforma cobra comissão sobre vendas?', resposta: 'Não! A Agroov não cobra comissão. A negociação é 100% direta entre comprador e vendedor.' },
    { pergunta: 'Como faço para renovar meu plano?', resposta: 'Quando o prazo vencer, o sistema exibirá automaticamente a opção de renovação. Basta realizar um novo pagamento via PIX.' },
    { pergunta: 'Posso editar meu anúncio depois de publicado?', resposta: 'Sim, porém apenas nas primeiras 24 horas após a publicação. Após esse período, por segurança, você precisará entrar em contato com o suporte via WhatsApp ou e-mail para solicitar alterações.' },
    { pergunta: 'Como contato o suporte?', resposta: 'Envie um e-mail para agroov2026@gmail.com. Estamos sempre prontos para ajudar!' }
]

function Ajuda() {
    const [secaoAberta, setSecaoAberta] = useState('comprador')
    const [faqAberta, setFaqAberta] = useState(null)

    return (
        <div className="ajuda-page">
            <section className="ajuda-hero-image">
                <img src="/logo/banner-ajuda.png" alt="Central de Ajuda Agroov" className="banner-ajuda" />
            </section>

            {/* Navegação por Seções */}
            <section className="ajuda-nav-section">
                <div className="ajuda-nav">
                    {secoes.map(secao => (
                        <button
                            key={secao.id}
                            className={`ajuda-nav-btn ${secaoAberta === secao.id ? 'active' : ''}`}
                            onClick={() => setSecaoAberta(secao.id)}
                            style={{ '--btn-color': secao.cor }}
                        >
                            {secao.titulo}
                        </button>
                    ))}
                </div>
            </section>

            {/* Conteúdo da Seção Ativa */}
            <section className="ajuda-content-section">
                {secoes.filter(s => s.id === secaoAberta).map(secao => (
                    <div key={secao.id} className="ajuda-secao">
                        <div className="secao-header">
                            <span className="secao-icone" style={{ background: secao.cor }}>{secao.icone}</span>
                            <div>
                                <h2>{secao.titulo}</h2>
                                <p>{secao.subtitulo}</p>
                            </div>
                        </div>

                        <div className="passos-timeline">
                            {secao.passos.map((passo, idx) => (
                                <div key={idx} className="passo-item" style={{ '--passo-color': secao.cor }}>
                                    <div className="passo-marker">
                                        <span className="passo-num">{passo.numero}</span>
                                        {idx < secao.passos.length - 1 && <div className="passo-line" />}
                                    </div>
                                    <div className="passo-body">
                                        <h3>{passo.titulo}</h3>
                                        <p>{passo.descricao}</p>
                                        {passo.extra && (
                                            <div className="passo-extras">
                                                {passo.extra.map((item, i) => (
                                                    <div key={i} className="extra-card">
                                                        <strong>{item.label}</strong>
                                                        <span className="extra-valor">{item.valor}</span>
                                                        <span className="extra-desc">{item.desc}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        {passo.dica && (
                                            <div className="passo-dica">
                                                <span className="dica-icon">💡</span>
                                                <span>{passo.dica}</span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </section>

            {/* FAQ */}
            <section className="ajuda-faq-section">
                <h2 className="faq-titulo">Perguntas Frequentes</h2>
                <div className="faq-list">
                    {faqItems.map((item, idx) => (
                        <div
                            key={idx}
                            className={`faq-item ${faqAberta === idx ? 'open' : ''}`}
                            onClick={() => setFaqAberta(faqAberta === idx ? null : idx)}
                        >
                            <div className="faq-question">
                                <span>{item.pergunta}</span>
                                <span className="faq-toggle">{faqAberta === idx ? '−' : '+'}</span>
                            </div>
                            {faqAberta === idx && (
                                <div className="faq-answer">
                                    <p>{item.resposta}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </section>

            {/* CTA */}
            <section className="ajuda-cta">
                <h2>Ainda tem dúvidas?</h2>
                <p>Nossa equipe está pronta para te ajudar.</p>
                <div className="ajuda-cta-actions">
                    <a href="mailto:agroov2026@gmail.com" className="btn btn-primary btn-lg">📧 Enviar E-mail</a>
                    <Link to="/" className="btn btn-outline btn-lg">🏠 Voltar para Home</Link>
                </div>
            </section>
        </div>
    )
}

export default Ajuda
